// extracted by mini-css-extract-plugin
module.exports = {"sale-home":"AllSales_sale-home__18tPk","sale-time":"AllSales_sale-time__2z9NZ","sale-unit":"AllSales_sale-unit__2aMQX","sale-link":"AllSales_sale-link__2ECjX"};